import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {User} from '../../../models/user';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {

  constructor(
    public authenticationService: AuthenticationService,
    public utilsService: UtilsService,
  ) {
  }

  ngOnInit() {
  }

  getUserCurrent(): User {
    if (!this.authenticationService.userCurrent) {
      return this.authenticationService.userAuthenticated;
    }
    return this.authenticationService.userCurrent;
  }

  stopImpersonateUser() {
    this.utilsService.lockUi();
    this.authenticationService.stopImpersonateUser();
  }
}
